import {
	IconEnvelopePenOutline18 as EnvelopePen,
	IconInboxArrowDownOutline18 as InboxArrowDown,
	IconRouteOutline18 as Route,
} from "nucleo-ui-outline-18"

import type { OptionCard } from "@productlane/ui"

export type ForwardedEmailHandling = "AUTO" | "ORIGINAL_SENDER" | "FORWARDER"

export type ForwardedContactSide = "FORWARDER" | "ORIGINAL_SENDER"

export const FORWARDED_MODE_OPTIONS: readonly OptionCard<ForwardedEmailHandling>[] =
	[
		{
			value: "AUTO",
			label: "Automatic",
			Icon: Route,
			description: "The person who forwarded it, unless they are on your team.",
		},
		{
			value: "ORIGINAL_SENDER",
			label: "Original sender",
			Icon: EnvelopePen,
			description:
				"Always the person who wrote the message inside the forward.",
		},
		{
			value: "FORWARDER",
			label: "Forwarder",
			Icon: InboxArrowDown,
			description: "Always the person who forwarded it to your inbox.",
		},
	]

export interface ForwardedCase {
	key: string
	forwarder: string
	originalSender: string
	forwarderIsTeammate: boolean
}

const SAMPLE_FORWARDER = "hr@customer.com"
const SAMPLE_SENDER = "raphael@customer.com"

// The teammate case uses the reader's own address, so the row names a person
// they recognise rather than a placeholder.
export function forwardedCases(
	teammateEmail: string | null | undefined,
): readonly [ForwardedCase, ForwardedCase] {
	return [
		{
			key: "customer",
			forwarder: SAMPLE_FORWARDER,
			originalSender: SAMPLE_SENDER,
			forwarderIsTeammate: false,
		},
		{
			key: "teammate",
			forwarder: teammateEmail?.trim() || "you@yourteam.com",
			originalSender: SAMPLE_SENDER,
			forwarderIsTeammate: true,
		},
	]
}

// Mirrors resolveForwardedContactSource on the server, so the preview cannot
// drift from what the inbox actually does.
export function forwardedCaseOutcome(
	mode: ForwardedEmailHandling,
	forwardedCase: ForwardedCase,
): ForwardedContactSide {
	if (mode === "FORWARDER") return "FORWARDER"
	if (mode === "ORIGINAL_SENDER") return "ORIGINAL_SENDER"
	return forwardedCase.forwarderIsTeammate ? "ORIGINAL_SENDER" : "FORWARDER"
}

export function forwardedCaseContact(
	mode: ForwardedEmailHandling,
	forwardedCase: ForwardedCase,
): string {
	return forwardedCaseOutcome(mode, forwardedCase) === "FORWARDER"
		? forwardedCase.forwarder
		: forwardedCase.originalSender
}
